import { DateTime } from "luxon";
import { useLocale } from "~/composables/useInternationalization";

const useCurrentDateTime = () =>
  useState("currentDateTime", () =>
    DateTime.local().setLocale(useLocale().value)
  );

export const useDateString = () =>
  useState("dateString", () => {
    const currentDateTime = useCurrentDateTime().value;

    // Customize the formatting options to display the date in "01.Marz 2024" format
    const dateString = currentDateTime.toFormat("dd.LLLL yyyy", {
      locale: useLocale().value
    });

    return dateString;
  });

export const useTimeString = () => useState("timeString", () =>
  useCurrentDateTime().value.toLocaleString(DateTime.TIME_SIMPLE)
);

export const useCurrentDay = () => useState("currentDay", () => useCurrentDateTime().value.day);

export const useCurrentWeekdayString = () => useState("weekdayString", () => useCurrentDateTime().value.weekdayShort);

export const useCurrentMonthString = () => useState("currentMonth", () =>
  useCurrentDateTime().value.toLocaleString({ month: "long" })
);

export const useCurrentSeason = () =>
  useState("seasonString", () => {
    const { t } = useI18n();
    const currentDate = useCurrentDateTime().value;

    // Start dates of each season
    const seasons = {
      winter: DateTime.local(currentDate.year, 12, 21),
      spring: DateTime.local(currentDate.year, 3, 20),
      summer: DateTime.local(currentDate.year, 6, 21),
      autumn: DateTime.local(currentDate.year, 9, 23)
    };

    let seasonKey = "winter";
    if (currentDate >= seasons.spring && currentDate < seasons.summer) {
      seasonKey = "spring";
    } else if (currentDate >= seasons.summer && currentDate < seasons.autumn) {
      seasonKey = "summer";
    } else if (currentDate >= seasons.autumn && currentDate < seasons.winter) {
      seasonKey = "autumn";
    }

    return {
      key: seasonKey,
      value: t(`seasons.${seasonKey}`)
    };
  });

const updateTime = () => {
  useCurrentDateTime().value = DateTime.local().setLocale(useLocale().value);

  useTimeString().value = useCurrentDateTime().value.toLocaleString({
    ...DateTime.TIME_SIMPLE,
    hour12: false
  });
  useDateString().value = useCurrentDateTime().value.toLocaleString(
    DateTime.DATE_MED
  );
  useCurrentWeekdayString().value = useCurrentDateTime().value.weekdayShort;
  useCurrentDay().value = useCurrentDateTime().value.day; // Update current day
  useCurrentMonthString().value = useCurrentDateTime().value.toLocaleString({
    month: "long"
  });
};

const EVERY_15_SECONDS = 15_000;

updateTime();
setInterval(updateTime, EVERY_15_SECONDS);
